export default __webpack_public_path__ + "static/media/banner_4.00920ab8.jpg";